import { useContext } from "react";
import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import DropdownIcon from "../../DropdownIcon";
import { classes } from "../classes";

export default function State({ context }) {

    const {
        stateOccurrence, setStateOccurrence
    } = useContext(context);

    return (
        <>
            <Typography style={classes.labelInput}>
                Estados da Ocorrência:
            </Typography>
            <FormControl variant="outlined" style={classes.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    value={stateOccurrence}
                    onChange={(e) => { setStateOccurrence(e.target.value); }}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="true">Encaminhadas</MenuItem>
                    <MenuItem value="false">Não Encaminhadas</MenuItem>
                </Select>
            </FormControl>
        </>
    )
}